const configs = {
  apiURL: process.env.REACT_APP_API_URL + '/v1',
  storageUrl: process.env.REACT_APP_API_URL,
};

export default configs;
